import React from 'react'
import { useState } from 'react';
import {FiChevronRight} from "react-icons/fi";
import SubmenuSide from "./SubmenuSide";

const SubmenuDropdown = ({submenus}) => {

    //menu dropdown
    const [showSubmenuSide, setShowSubmenuSide] = useState(null);
    const [dropdownSide, setDropdownSide] = useState(false);

    //first submenu
    const [showSecondSubmenuSide, setShowSecondSubmenuSide] = useState(null);
    const [dropdownSecondSide, setDropdownSecondSide] = useState(false);

    //second submenu
    const [showThirdSubmenuSide, setShowThirdSubmenuSide] = useState(null);
    const [dropdownThirdSide, setDropdownThirdSide] = useState(false);


    //show menu dropdown
    const showSubmenuSideHandler = (menuVoice) => {

        if(typeof menuVoice == "undefined" || menuVoice.length <= 0)
        {
            hideSubmenuSideHandler();

            return false;
        }

        if(typeof submenus[menuVoice] == "undefined" || typeof submenus[menuVoice].submenu == "undefined")
        { 
            hideSubmenuSideHandler();
            
            return false;
        }

        if(dropdownSide && showSubmenuSide == menuVoice)
        {
            if(typeof document.getElementById("divSubmenuSide").getElementsByTagName('div')[0] == "undefined")
            {
                setDropdownSide(false);
            }
        }
        else
        {
            setDropdownSide(true);

            setShowSubmenuSide(menuVoice);

            let divSubmenuHeight = document.getElementById("divChildSubmenu").clientHeight;
            document.getElementById("divSubmenuSide").style.minHeight = divSubmenuHeight + 'px';
        }

        return true;
    }

    //hide menu dropdown
    const hideSubmenuSideHandler = () => {
        setDropdownSide(false);
        setShowSubmenuSide(null);

        hideSecondSubmenuSideHandler();

        return false;
    }


    //show first submenu
    const showSecondSubmenuSideHandler = (menuVoice) => {
        if(typeof menuVoice == "undefined" || menuVoice.length <= 0)
        {
            hideSecondSubmenuSideHandler();

            return false;
        }

        if(typeof submenus[showSubmenuSide].submenu[menuVoice] == "undefined" || typeof submenus[showSubmenuSide].submenu[menuVoice].submenu == "undefined")
        {  
            hideSecondSubmenuSideHandler();
            
            return false;
        }

        if(showSecondSubmenuSide || showSecondSubmenuSide != menuVoice)
        {
            setDropdownSecondSide(true);

            setShowSecondSubmenuSide(menuVoice);
        }

        return true;
    }

    //hide first submenu
    const hideSecondSubmenuSideHandler = () => {
        setDropdownSecondSide(false);
        setShowSecondSubmenuSide(null);

        hideThirdSubmenuSideHandler();

        return false;
    }


    //show second submenu
    const showThirdSubmenuSideHandler = (menuVoice) => {
        if(typeof menuVoice == "undefined" || menuVoice.length <= 0)
        {
            hideThirdSubmenuSideHandler();

            return false;
        }

        if(typeof submenus[menuVoice] == "undefined" || typeof submenus[menuVoice].submenu == "undefined")
        {  
            hideThirdSubmenuSideHandler();
            
            return false;
        }

        if(dropdownThirdSide && showThirdSubmenuSide == menuVoice)
        {
            if(typeof document.getElementById("divThirdSubmenuSide").getElementsByTagName('div')[0] == "undefined")
            {
                setDropdownThirdSide(false);
            }
        }
        else
        {
            setDropdownThirdSide(true);

            setShowThirdSubmenuSide(menuVoice);

            let divSubmenuHeight = document.getElementById("divThirdChildSubmenu").clientHeight;
            document.getElementById("divThirdSubmenuSide").style.minHeight = divSubmenuHeight + 'px';
        }

        return true;
    }

    //hide second submenu
    const hideThirdSubmenuSideHandler = () => {
        setDropdownThirdSide(false);
        setShowThirdSubmenuSide(null);

        return false;
    }

    return (
                <div className='h-full'>
                    <div className={dropdownSide ? 'border-r-1 border-white' : ''} style={{float: 'left', width: '210px'}} id="divChildSubmenu">
                        <ul className="h-full" style={{paddingRight: "16px"}} >
                            {(typeof submenus != "undefined" && submenus.length > 0) ? submenus.map((submenu, key) => (
                                    key > 0 ?
                                        <li className={`text-xs xl:text-sm 2xl:text-base text-gray-light font-medium h-full py-1 w-full ${submenu.title === 'CORCYMbeat' ? '' : 'uppercase'}`} key={key} style={{listStyleType: "none"}}>
                                            <div className='h-full w-full' id={`menuVoice${key}`}>
                                                {
                                                    submenu.submenu ?
                                                        <div className='h-full hover:text-red-primary d-flex align-center cursor-pointer' onMouseOver={() => showSubmenuSideHandler(key)}>
                                                            <div className='w-10/12 h-full' style={{float: 'left'}}>
                                                                {/* <a href={submenu.to} className='h-full d-flex items-center' aria-haspopup="menu">{submenu.title} </a> */}
                                                                <a
                                                                    href={submenu.to}
                                                                    target={submenu.to.startsWith('http') ? '_blank' : '_self'}
                                                                    rel={submenu.to.startsWith('http') ? 'noopener noreferrer' : undefined}
                                                                    className='h-full d-flex items-center'
                                                                    aria-haspopup="menu"
                                                                    >
                                                                    {submenu.title}
                                                                </a>
                                                            </div>
                                                            <div className='w-2/12 h-full' style={{float: 'left'}}>
                                                                <FiChevronRight className="m-auto w-full d-flex my-auto text-right cursor-pointer mr-0" style={{justifyContent: 'end', width: '25px', height: '16px'}}/>
                                                            </div>
                                                        </div>
                                                    :
                                                        // <a href={submenu.to} className='h-full d-flex items-center hover:text-red-primary' aria-haspopup="menu">{submenu.title}</a>
                                                        <a
                                                            href={submenu.to}
                                                            target={submenu.to.startsWith('http') ? '_blank' : '_self'}
                                                            rel={submenu.to.startsWith('http') ? 'noopener noreferrer' : undefined}
                                                            className='h-full d-flex items-center hover:text-red-primary'
                                                            aria-haspopup="menu"
                                                            >
                                                            {submenu.title}
                                                        </a>
                                                }
                                            </div>
                                        </li>
                                    :
                                    ''
                            ))
                            :
                            ''}
                        </ul>
                    </div>
                    <div id="divSubmenuSide" style={{zIndex: '999999', float: 'left'}} className="h-full" onMouseLeave={hideSubmenuSideHandler}>
                        {
                            dropdownSide && typeof submenus[showSubmenuSide].submenu != "undefined" ?
                                <SubmenuSide
                                    submenus={submenus[showSubmenuSide].submenu} 
                                    hideSecondSubmenuSideHandler={hideSecondSubmenuSideHandler} 
                                    showSecondSubmenuSideHandler={showSecondSubmenuSideHandler} 
                                    showSecondSubmenuSide={showSecondSubmenuSide}
                                    dropdownSecondSide={dropdownSecondSide}
                                    showThirdSubmenuSideHandler={showThirdSubmenuSideHandler}
                                    hideThirdSubmenuSideHandler={hideThirdSubmenuSideHandler}
                                    showThirdSubmenuSide={showThirdSubmenuSide}
                                    dropdownThirdSide={dropdownThirdSide}
                                />
                            :
                                ''
                        }
                    </div>
                </div>
            );
  };
  
  export default SubmenuDropdown;